export default __webpack_public_path__ + "static/media/arrow_right_blue.1098dc97.svg";